// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popUpNewsCarousel_aM7n6 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow-x: hidden;
  position: relative;
  padding: 4px 10px;
  flex: 1 1;
  margin: 0 10px;
  mask-image: linear-gradient(to right, transparent, var(--27272a-color) 20%, var(--27272a-color) 30%, transparent);

  @media (width<=950px) {
    display: none;
  }

  @media (1000px<=width) {
    flex: 2 1;
  }

  @media (1100px<=width) {
    flex: 3 1;
  }

  @media (1300px<=width) {
    flex: 4 1;
    margin: 0 -3vw 0 -1vw;
  }

  .popUpNewsCarouselContent_yWvnO {
    display: flex;
    gap: 10px;
    animation: scroll_gyBgv 400s linear infinite;
    padding: 0 10px;
  }

  &:hover .popUpNewsCarouselContent_yWvnO {
    animation-play-state: paused;
  }

  .popUpNewsCarouselItem_r2Fl5 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 2px 6px 2px 2px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
    background: transparent;
    flex-shrink: 0;
    background: #00000026;

    &:hover {
      background: #1a1e1b;
    }

    &:last-child {
      border: none;
    }

    &::before {
      content: attr(data-tooltip);
      position: absolute;
      top: calc(120% + 4px);
      left: 50%;
      transform: translateX(-50%);
      padding: 5px 10px;
      background: var(--_000000cc-background);
      color: var(--white-color);
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;

    }

    &::after {
      content: "";
      position: absolute;
      top: calc(100% - 2px);
      left: 50%;
      transform: translateX(-50%);
      border: 5px solid transparent;
      border-bottom-color: var(--_000000cc-background);
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
    }

    &:hover::before,
    &:hover::after {
      opacity: 1;
      visibility: visible;
    }

    img {
      width: 30px;
      height: 30px;
      object-fit: cover;
      border-radius: 8px;
    }

    .popUpNewsCarouselItemContent_B0uxM {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      gap: 6px;

      b {
        font-size: 12px;
        font-weight: 600;
        line-height: 10px;
        /* margin-top: 4px; */
        width: max-content;
        color: #fff;
      }

      span {
        font-size: 8px;
        font-weight: 300;
      }

      p {
        margin: 0;
        color: #c1c1c1;
        font-size: 12px;
        line-height: 10px;
      }
    }

    svg {
      width: 10px;
      height: 10px;
    }
  }
}





@keyframes scroll_gyBgv {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavbarAdmin/NavbarNews.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,SAAO;EACP,cAAc;EAEd,iHAAiH;;EAEjH;IACE,aAAa;EACf;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAO;IACP,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,4CAAsC;IACtC,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,uCAAuC;IACvC,uBAAuB;IACvB,cAAc;IACd,qBAAqB;;IAErB;MACE,mBAAmB;IACrB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,qBAAqB;MACrB,SAAS;MACT,2BAA2B;MAC3B,iBAAiB;MACjB,uCAAuC;MACvC,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,mBAAmB;MACnB,UAAU;MACV,kBAAkB;MAClB,yBAAyB;;IAE3B;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,qBAAqB;MACrB,SAAS;MACT,2BAA2B;MAC3B,6BAA6B;MAC7B,gDAAgD;MAChD,UAAU;MACV,kBAAkB;MAClB,yBAAyB;IAC3B;;IAEA;;MAEE,UAAU;MACV,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,uBAAuB;MACvB,QAAQ;;MAER;QACE,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;QACrB,kBAAkB;QAClB,WAAW;MACb;;MAEA;QACE,cAAc;QACd,gBAAgB;MAClB;;MAEA;QACE,SAAS;QACT,cAAc;QACd,eAAe;QACf,iBAAiB;MACnB;IACF;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;;;;;AAMA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".popUpNewsCarousel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  overflow-x: hidden;\n  position: relative;\n  padding: 4px 10px;\n  flex: 1;\n  margin: 0 10px;\n  -webkit-mask-image: linear-gradient(to right, transparent, var(--27272a-color) 20%, var(--27272a-color) 30%, transparent);\n  mask-image: linear-gradient(to right, transparent, var(--27272a-color) 20%, var(--27272a-color) 30%, transparent);\n\n  @media (width<=950px) {\n    display: none;\n  }\n\n  @media (1000px<=width) {\n    flex: 2;\n  }\n\n  @media (1100px<=width) {\n    flex: 3;\n  }\n\n  @media (1300px<=width) {\n    flex: 4;\n    margin: 0 -3vw 0 -1vw;\n  }\n\n  .popUpNewsCarouselContent {\n    display: flex;\n    gap: 10px;\n    animation: scroll 400s linear infinite;\n    padding: 0 10px;\n  }\n\n  &:hover .popUpNewsCarouselContent {\n    animation-play-state: paused;\n  }\n\n  .popUpNewsCarouselItem {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 2px 6px 2px 2px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.2s ease-in-out;\n    background: transparent;\n    flex-shrink: 0;\n    background: #00000026;\n\n    &:hover {\n      background: #1a1e1b;\n    }\n\n    &:last-child {\n      border: none;\n    }\n\n    &::before {\n      content: attr(data-tooltip);\n      position: absolute;\n      top: calc(120% + 4px);\n      left: 50%;\n      transform: translateX(-50%);\n      padding: 5px 10px;\n      background: var(--_000000cc-background);\n      color: var(--white-color);\n      border-radius: 4px;\n      font-size: 12px;\n      white-space: nowrap;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s ease;\n\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: calc(100% - 2px);\n      left: 50%;\n      transform: translateX(-50%);\n      border: 5px solid transparent;\n      border-bottom-color: var(--_000000cc-background);\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s ease;\n    }\n\n    &:hover::before,\n    &:hover::after {\n      opacity: 1;\n      visibility: visible;\n    }\n\n    img {\n      width: 30px;\n      height: 30px;\n      object-fit: cover;\n      border-radius: 8px;\n    }\n\n    .popUpNewsCarouselItemContent {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: center;\n      gap: 6px;\n\n      b {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 10px;\n        /* margin-top: 4px; */\n        width: max-content;\n        color: #fff;\n      }\n\n      span {\n        font-size: 8px;\n        font-weight: 300;\n      }\n\n      p {\n        margin: 0;\n        color: #c1c1c1;\n        font-size: 12px;\n        line-height: 10px;\n      }\n    }\n\n    svg {\n      width: 10px;\n      height: 10px;\n    }\n  }\n}\n\n\n\n\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-100%);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popUpNewsCarousel": `popUpNewsCarousel_aM7n6`,
	"scroll": `scroll_gyBgv`,
	"popUpNewsCarouselContent": `popUpNewsCarouselContent_yWvnO`,
	"popUpNewsCarouselItem": `popUpNewsCarouselItem_r2Fl5`,
	"popUpNewsCarouselItemContent": `popUpNewsCarouselItemContent_B0uxM`
};
export default ___CSS_LOADER_EXPORT___;
